﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalMarketing`,
  scopes: ExtHubRequest,
});
const promoApi = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalPromoItem`,
  scopes: ExtHubRequest,
});
const socialsApi = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/socials`,
  scopes: ExtHubRequest,
});
const XApi = new API({ url: '/x/tweet', scopes: ExtHubRequest });
const linkedinApiAuth = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/socials/auth`,
  scopes: ExtHubRequest,
});
const linkedinApi = new API({ url: `${process.env.REACT_APP_LINKEDIN_REST_URL}` });

api.createEntities([
  { name: 'GetMarketingList' },
  { name: 'GetCostList' },
  { name: 'GetMarketsServedList' },
  { name: 'getMarketItemByName' },
  { name: 'GetMarketByID' },
  { name: 'GetMarketingCmsList' },
  { name: 'GetCampaigns' },
  { name: 'SaveMarketingItem' },
  { name: 'DeleteMarketingItem' },
  { name: 'UploadMarketingFile' },

  { name: 'GetPromoItemCostList' },
  { name: 'GetPromoItemServedList' },
  { name: 'getPromoItemByName' },
  { name: 'GetPromoItemCmsList' },
  { name: 'SavePromoItem' },
  { name: 'DeletePromoItem' },
  { name: 'UploadPromoItemFile' },
]);

promoApi.createEntities([
  { name: 'GetPromoItemList' },
  { name: 'GetPromoItemByID' },
  { name: 'EmailForm' },
]);

socialsApi.createEntities([{ name: 'RequestNewPost' }]);

const GetMarketingItems = () => api.endpoints.GetMarketingList.post();
const GetCostList = () => api.endpoints.GetCostList.post();
const GetMarketsServedList = () => api.endpoints.GetMarketsServedList.post();
const GetMarketByName = (body) => api.endpoints.getMarketItemByName.post(body);
const GetMarketingCmsList = () => api.endpoints.GetMarketingCmsList.post();
const GetMarketByID = (body) => api.endpoints.GetMarketByID.post(body);
const GetCampaigns = () => api.endpoints.GetCampaigns.post();
const SaveMarketingItem = (body) => api.endpoints.SaveMarketingItem.post(body);
const DeleteMarketingItem = (body) => api.endpoints.DeleteMarketingItem.post(body);
const UploadMarketingFile = (data) => api.endpoints.UploadMarketingFile.postData(data);

const GetPromoItemCmsList = () => api.endpoints.GetPromoItemCmsList.post();

const SavePromoItem = (body) => api.endpoints.SavePromoItem.post(body);
const DeletePromoItem = (body) => api.endpoints.DeletePromoItem.post(body);
const UploadPromoItemFile = (data) => api.endpoints.UploadPromoItemFile.postData(data);

const EmailForm = (body) => promoApi.endpoints.EmailForm.post(body);
const GetPromoItemByID = (body) => promoApi.endpoints.GetPromoItemByID.post(body);
const GetPromoItemList = () => promoApi.endpoints.GetPromoItemList.post();

const GetSocialCategories = () => socialsApi.createBasicCRUDEndpoints('category').get();
const GetPostKeywords = ({ queryKey }) => {
  const [_, categoryId] = queryKey;
  return socialsApi.createBasicCRUDEndpoints('keywords', `categoryID=${categoryId}`).get();
};
const SearchPostKeywords = ({ queryKey }) => {
  const [_, searchTerm] = queryKey;
  return socialsApi.createBasicCRUDEndpoints('keywords/search', `searchTerm=${searchTerm}`).get();
};

const GetPostWithTitle = ({ queryKey }) => {
  const [_, title] = queryKey;
  return socialsApi.createBasicCRUDEndpoints(`messages/title/${title}`).get();
};
const GetSocialCategoryById = (id) => socialsApi.createBasicCRUDEndpoints(`category/${id}`).get();
const GetMessages = ({ queryKey }) => {
  let [filter] = queryKey;
  filter.categoryID = filter.categoryID || 0;
  // let queryObject = {categoryID, published};

  const queries = [];
  for (const [key, value] of Object.entries(filter)) {
    queries.push({ queryParam: key, queryVal: value });
  }
  return socialsApi.createBasicCRUDEndpoints('messages').getMultipleQueryString(queries)();
};
const RequestNewPost = (body) => socialsApi.createBasicCRUDEndpoints('requests').post(body);
const CreateMessages = (body) => socialsApi.createBasicCRUDEndpoints('messages').post(body);
const AddToMessageHistory = (body) =>
  socialsApi.createBasicCRUDEndpoints('messages/history').post(body);

const UpdateMessages = (body) => {
  const { Post } = body;
  return socialsApi.createBasicCRUDEndpoints(`messages/${Post.id}`).put(Post);
};

const PatchMessage = (body, queries) => {
  const id = body.postsMedia[0].PostId;
  return socialsApi.createBasicCRUDEndpoints(`messages/${id}`).patch(body, queries);
};

const DeleteMessages = (id) => {
  return socialsApi.createBasicCRUDEndpoints(`messages/${id}`).delete(id);
};

const UpdateRequestStatus = ({ queryKey }) => {
  const [id, status] = queryKey;
  return socialsApi.createBasicCRUDEndpoints(`requests/${id}`, `status=${status}`).patch();
};
const GetSocialMediaPostRequests = (queries) =>
  socialsApi.createBasicCRUDEndpoints('requests').getMultipleQueryString(queries);
const UploadSocialsImage = (data, queries) =>
  socialsApi.createBasicCRUDEndpoints('messages/files').postData(data, queries);
const GetSocialMediaFileList = (queries) =>
  socialsApi.createBasicCRUDEndpoints('messages/files').getMultipleQueryString(queries);

const GetLinkedinToken = (queries) =>
  linkedinApiAuth.createBasicCRUDEndpoints('linkedin').getMultipleQueryString(queries);
const PostMessageToLinkedin = (body, jwt, queries) =>
  socialsApi.createBasicCRUDEndpoints('linkedin/posts').post(
    null,
    {
      crossDomain: true,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        linkedinJwt: jwt,
      },
      body: JSON.stringify({ postBody: JSON.stringify(body) }),
    },
    queries
  );
const GetXToken = (queries, message) =>
  linkedinApiAuth.createBasicCRUDEndpoints('x').postMultipleQueryString(queries, message);
const PostXTweet = (data) => socialsApi.createBasicCRUDEndpoints('x/tweet').post(data);

export {
  GetMarketingItems,
  GetCostList,
  GetMarketsServedList,
  GetMarketByName,
  GetMarketingCmsList,
  GetMarketByID,
  GetCampaigns,
  SaveMarketingItem,
  DeleteMarketingItem,
  UploadMarketingFile,
  GetPromoItemList,
  GetPromoItemCmsList,
  GetPromoItemByID,
  SavePromoItem,
  DeletePromoItem,
  UploadPromoItemFile,
  EmailForm,
  GetSocialCategories,
  GetSocialCategoryById,
  GetMessages,
  CreateMessages,
  UpdateMessages,
  PatchMessage,
  GetPostKeywords,
  SearchPostKeywords,
  RequestNewPost,
  GetSocialMediaPostRequests,
  UpdateRequestStatus,
  GetPostWithTitle,
  UploadSocialsImage,
  GetSocialMediaFileList,
  GetLinkedinToken,
  AddToMessageHistory,
  GetXToken,
  PostXTweet,
  DeleteMessages,
  PostMessageToLinkedin,
};
